export const windowLock = () => {
  const loader = document.getElementById("loader")
  if (loader) loader.style.display = "block"
}

export const windowRelease = () => {
  const loader = document.getElementById("loader")
  if (loader) loader.style.display = "none"
}
